import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PageNotFoundComponent } from './page-not-found-component';

export function PageNotFoundFactory() {
  return (
    <BaseLayoutFactory>
      <PageNotFoundComponent />
    </BaseLayoutFactory>
  );
}
